export type ServiceKey = 'audit' | 'build' | 'trades'

export interface ServiceDef {
  key: ServiceKey
  image: string
  badge: string
  title: string
  description: string
  action: string
  path: string
}

/** The three services offered on the investor side, each routing to its own onboarding flow. */
export const SERVICES: ServiceDef[] = [
  {
    key: 'audit',
    image: '/img/service-audit-portfolio.svg',
    badge: 'Already investing',
    title: 'Audit My Portfolio',
    description:
      "See what's working, what's not, and where to improve — reviewed by a financial expert.",
    action: 'Start portfolio audit',
    path: '/import-portfolio',
  },
  {
    key: 'build',
    image: '/img/service-build-portfolio.svg',
    badge: 'Starting fresh',
    title: 'Build My Portfolio',
    description: 'Start from zero with a portfolio designed around your goals.',
    action: 'Build a plan',
    path: '/build-portfolio',
  },
  {
    key: 'trades',
    image: '/img/service-audit-trades.svg',
    badge: 'Active trader',
    title: 'Audit My Trades',
    description: 'Get expert review on your trading activity and patterns.',
    action: 'Review my trades',
    path: '/audit-trades',
  },
]
